import { Pipe, PipeTransform } from '@angular/core';

/**
 * Filters a list by a text term against one of its string fields (default: `name`).
 * Pure pipe → only recomputes when the list, term or field reference changes.
 *
 * Usage: `optionTypes | filterByName: searchBox.term`
 */
@Pipe({ name: 'filterByName' })
export class FilterByNamePipe implements PipeTransform {
  transform<T>(items: T[] | null | undefined, term: string, field: keyof T = 'name' as keyof T): T[] {
    if (!items) {
      return [];
    }
    const t = (term ?? '').trim().toLowerCase();
    if (!t) {
      return items;
    }
    return items.filter((i) => String((i as any)[field] ?? '').toLowerCase().includes(t));
  }
}
